import { MDXProvider } from "@mdx-js/react";
import { Pencil } from "lucide-react";
import { Suspense } from "react";
import { Navigate, useParams } from "react-router-dom";

import { mdxComponents } from "@app/mdx.tsx";
import { findGuide } from "@lib/guides.ts";

const REPO_URL = import.meta.env.VITE_REPO_URL as string | undefined;

export function GuidePage() {
  const { version = "", slug = "" } = useParams();
  const guide = findGuide(version, slug);

  if (!guide) return <Navigate to={`/${version}`} replace />;

  const { Component } = guide;

  return (
    <div className="px-4 py-7 sm:px-7">
      <article className="max-w-[46rem]">
        <h1 className="text-[28px] font-semibold leading-tight tracking-tight text-ink">
          {guide.title}
        </h1>
        {guide.summary ? (
          <p className="mt-2 text-[15px] text-muted">{guide.summary}</p>
        ) : null}

        <div className="gt-prose mt-6">
          <Suspense fallback={<GuideSkeleton />}>
            <MDXProvider components={mdxComponents}>
              <Component />
            </MDXProvider>
          </Suspense>
        </div>

        {REPO_URL ? (
          <footer className="mt-12 border-t border-line pt-4">
            <a
              href={`${REPO_URL}/edit/main/content/${version}/guides/`}
              target="_blank"
              rel="noreferrer noopener"
              className="inline-flex items-center gap-1.5 text-[13px] text-muted transition hover:text-accent"
            >
              <Pencil className="size-3.5" aria-hidden />
              Improve this page
            </a>
          </footer>
        ) : null}
      </article>
    </div>
  );
}

function GuideSkeleton() {
  return (
    <div aria-hidden className="space-y-3">
      {[0, 1, 2, 3, 4].map((row) => (
        <div
          key={row}
          className="h-4 animate-pulse rounded-sm2 bg-surface-2"
          style={{ width: `${[95, 88, 70, 92, 60][row]}%` }}
        />
      ))}
    </div>
  );
}
